import Button from "./Components/Button"

export default function NavLayer2({ texts = [], hrefs = [], activeIndex = 0 }) {
  const count = texts.length;
  const maxWidth = count * 200 + (count - 1) * 20;
  
  return (
    <div className="w-full flex justify-center items-center">

      <div className="w-full flex gap-5 rounded-xl border border-zi-border-dark bg-zi-bg2-light dark:bg-zi-bg2-dark p-1.5 overflow-auto"
      style={{ maxWidth: `${maxWidth}px` }}>
        {texts.map((text, index) => (
          <Button
            key={index}
            text={text}
            href={hrefs[index]}
            active={index === activeIndex}
          />
        ))}
      </div>

    </div>
  );
}